import React, { useState } from "react";
import { Button, CircularProgress, Alert, Stack } from "@mui/material";
import { useUserInfo } from "../../utils/user";

const IG_AUTH_URL = import.meta.env.VITE_IG_AUTH_URL;

export default function ConnectInstagramButton() {
  const { id: userId } = useUserInfo();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const connect = async () => {
    if (!userId) {
      setError("User not logged in");
      return;
    }

    setLoading(true);
    setError("");

    try {
      window.location.href = IG_AUTH_URL;
    } catch (e) {
      setError(e.message);
      setLoading(false);
    }
  };

  return (
    <Stack spacing={2}>
      {error && <Alert severity="error">{error}</Alert>}
      <Button
        variant="contained"
        onClick={connect}
        disabled={loading || !userId}
        startIcon={loading ? <CircularProgress size={18} /> : null}
      >
        Connect Instagram
      </Button>
    </Stack>
  );
}
